import React from 'react';
import {Button, TextButton} from '@wix/wix-ui-tpa/cssVars';
import {MessageActionParams} from './NoOnlineOrdersMessage.utils';

export enum NoOnlineOrdersActionsDataHooks {
  CtaButton = 'NoOnlineOrdersMessageDataHooks.CtaButton',
  SecondaryLink = 'NoOnlineOrdersMessageDataHooks.SecondaryLink',
}

interface NoOnlineOrdersActionsProps {
  actionParams: MessageActionParams;
}

export const NoOnlineOrdersActions = ({actionParams}: NoOnlineOrdersActionsProps) => {
  const {mainCta, secondaryLink} = actionParams;

  return (
    <>
      {mainCta && (
        <Button
          as={'a'}
          data-hook={NoOnlineOrdersActionsDataHooks.CtaButton}
          href={mainCta.url}
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
            window.open(mainCta.url, '_blank');
          }}>
          {mainCta.text}
        </Button>
      )}
      {secondaryLink && (
        <TextButton data-hook={NoOnlineOrdersActionsDataHooks.SecondaryLink} onClick={secondaryLink.onClick}>
          {secondaryLink.text}
        </TextButton>
      )}
    </>
  );
};
